// extracted by mini-css-extract-plugin
export default {"inputWrp":"MyInput_inputWrp__ABMo6","inputLabel":"MyInput_inputLabel__C3QbP","input":"MyInput_input__SKqq9","error":"MyInput_error__BNE4C","textarea":"MyInput_textarea__tMBi8"};